export default function Footer() {
  const footerLinks = {
    about: [
      { name: 'About Us', href: '#about' },
      { name: 'Contact Us', href: '#contact' },
      { name: 'FAQs', href: '#faqs' },
      { name: 'Join Us', href: 'https://docs.google.com/forms/d/e/1FAIpQLSf1_pmDnir9wO6A_cDHBPNg4ezmbiIf5P8ar6Qac2uzqy-TYw/viewform' },
      { name: 'Sponsors', href: '#sponsors' },
    ],
    team: [
      { name: 'Team', href: '#team' },
      { name: 'Administration', href: '#administration' },
      { name: 'Schedule', href: '#schedule' },
    ],
    venue: [
      { name: 'Stadium', href: '#stadium' },
      { name: 'FAQs', href: '#faqs' },
      { name: 'Maps', href: '#maps' },
    ],
    media: [
      { name: 'News', href: '#news' },
      { name: 'Photos', href: '#photos' },
      { name: 'Videos', href: '#videos' },
      { name: 'Live', href: '#live' },
    ],
    shop: [
      { name: 'Tickets', href: '#tickets' },
      { name: 'Shop', href: '#shop' },
    ],
  };

  return (
    <footer className="bg-gray-900 text-white">
      {/* Main Footer Content */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        {/* Logo */}
        <div className="text-center mb-12">
          <img
            src="https://tristatewarriors.com/wp-content/uploads/2024/02/test-.png"
            alt="Tri-State Warriors"
            className="h-16 mx-auto"
          />
        </div>

        {/* Footer Links Grid */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-8 mb-12">
          {/* About Column */}
          <div>
            <h3 className="text-base font-bold mb-4 text-red-500">ABOUT</h3>
            <ul className="space-y-2">
              {footerLinks.about.map((link) => (
                <li key={link.name}>
                  <a
                    href={link.href}
                    className="text-sm text-gray-400 hover:text-white transition-colors cursor-pointer"
                  >
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Team Column */}
          <div>
            <h3 className="text-base font-bold mb-4 text-red-500">TEAM</h3>
            <ul className="space-y-2">
              {footerLinks.team.map((link) => (
                <li key={link.name}>
                  <a
                    href={link.href}
                    className="text-sm text-gray-400 hover:text-white transition-colors cursor-pointer"
                  >
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Venue Column */}
          <div>
            <h3 className="text-base font-bold mb-4 text-red-500">VENUE</h3>
            <ul className="space-y-2">
              {footerLinks.venue.map((link) => (
                <li key={link.name}>
                  <a
                    href={link.href}
                    className="text-sm text-gray-400 hover:text-white transition-colors cursor-pointer"
                  >
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Media Column */}
          <div>
            <h3 className="text-base font-bold mb-4 text-red-500">MEDIA</h3>
            <ul className="space-y-2">
              {footerLinks.media.map((link) => (
                <li key={link.name}>
                  <a
                    href={link.href}
                    className="text-sm text-gray-400 hover:text-white transition-colors cursor-pointer"
                  >
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Shop Column */}
          <div>
            <h3 className="text-base font-bold mb-4 text-red-500">SHOP</h3>
            <ul className="space-y-2">
              {footerLinks.shop.map((link) => (
                <li key={link.name}>
                  <a
                    href={link.href}
                    className="text-sm text-gray-400 hover:text-white transition-colors cursor-pointer"
                  >
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-gray-800 bg-red-600">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-sm text-white text-center md:text-left">
              © TRI-STATE WARRIORS | All Rights Reserved
            </p>
            <div className="flex flex-wrap justify-center gap-4 text-sm">
              <a href="#terms" className="text-white hover:text-gray-200 transition-colors cursor-pointer whitespace-nowrap">
                TERMS OF USE
              </a>
              <span className="text-white">|</span>
              <a href="#privacy" className="text-white hover:text-gray-200 transition-colors cursor-pointer whitespace-nowrap">
                PRIVACY POLICY
              </a>
              <span className="text-white">|</span>
              <a href="#cookies" className="text-white hover:text-gray-200 transition-colors cursor-pointer whitespace-nowrap">
                COOKIE POLICY
              </a>
              <span className="text-white">|</span>
              <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="text-white hover:text-gray-200 transition-colors cursor-pointer whitespace-nowrap">
                Powered by Readdy
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
